import { deleteApi, get, post } from "../GenericServices";

const ProjectEstimate = {
  projectEstimateList: (queryString) => {
    return get(`project-estimate?${queryString}`);
  },
  saveNewProjectEstimate: (dto) => {
    return post("project-estimate", dto);
  },
  projectEstimateData: (id) => {
    return get(`project-estimate/${id}`);
  },
  projectEstimateDelete: (id) => {
    return deleteApi(`project-estimate/${id}`);
  },
  projectEstimateDocumentList: (id) => {
    return get(`project-estimate/${id}/document`);
  },
  projectEstimateWorkPackage: (id, queryString) => {
    return get(`project-estimate/${id}/work-package?${queryString}`);
  },
  clientsProjectEstimate: (queryString) => {
    return get(`project-estimate/client?${queryString}`);
  },
  saveProjectEstimateDocument: (id, queryString, file) => {
    return post(`project-estimate/${id}/document?${queryString}`, file);
  },
  uploadProjectEstimate: (id, wpId, year, file) => {
    return post(`project-estimate/${id}/cost-estimation/work-package/${wpId}/${year}/upload`, file);
  },
  uploadProjectEstimateKickOff: (id, wpId, year, file) => {
    return post(`project-estimate/${id}/kick-off/work-package/${wpId}/${year}/upload`, file);
  },
};

export default ProjectEstimate;
